const { get } = require('lodash');

module.exports = function(value) {
  return get(value, 'records', [])
    .sort((a, b) =>
      String(a.name)
        .toLowerCase()
        .localeCompare(String(b.name).toLowerCase())
    )
    .map(({ name }) => name)
    .join(', ');
};
